/*
 * Laundromat Label Co. seasonal decorations
 * Halloween (Oct 1 to Oct 31), Thanksgiving (Nov 1 to day after Thanksgiving),
 * Christmas (to Dec 26), New Year's (Dec 27 to Jan 2). Dates use Pacific time.
 * Preview any season: add ?season=halloween | thanksgiving | christmas | newyear | off
 * (applies to that page load only; nothing is remembered).
 * Decorations never take clicks (pointer-events: none) and never sit over
 * the product area: the bar and header stripe are backgrounds, and the
 * floating pieces only live in the empty side margins on wide screens.
 */
(function () {
  'use strict';

  var SEASONS = ['halloween', 'thanksgiving', 'christmas', 'newyear'];

  function pacificToday() {
    var o = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day };
  }

  // Fourth Thursday of November
  function thanksgivingDay(y) {
    var dow = new Date(Date.UTC(y, 10, 1)).getUTCDay();
    return 1 + ((4 - dow + 7) % 7) + 21;
  }

  function seasonFor(t) {
    var m = t.m, d = t.d;
    if (m === 10) return 'halloween';
    if (m === 11 && d <= thanksgivingDay(t.y) + 1) return 'thanksgiving';
    if (m === 11 || (m === 12 && d <= 26)) return 'christmas';
    if ((m === 12 && d >= 27) || (m === 1 && d <= 2)) return 'newyear';
    return null;
  }

  function pickSeason() {
    var q = null;
    try { q = new URLSearchParams(window.location.search).get('season'); } catch (e) {}
    if (q) q = q.toLowerCase();
    // Preview override applies only to the page opened with ?season=...; clear any old sticky value
    try { sessionStorage.removeItem('llcSeason'); } catch (e) {}
    if (q === 'auto') q = null;
    if (q === 'off') return null;
    if (q && SEASONS.indexOf(q) > -1) return q;
    return seasonFor(pacificToday());
  }

  var season = pickSeason();
  if (!season) return;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // ---------- Artwork (tiny inline SVGs) ----------
  function svg(vb, body) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb + '" aria-hidden="true">' + body + '</svg>';
  }
  var ART = {
    bat: function (c) {
      return svg('0 0 64 32', '<path fill="' + c + '" d="M32 9c-1.5-3-3-4.5-4-5l-1 4.5c-4-3-10-4.2-16-2.2 3 1.2 5 4 5 7-3-2-8-2-12 .2 6 1 10 5 12 10.5 2.5-3 6.5-4.2 10.5-3.2 1-3 3.5-4.3 5.5-4.3s4.5 1.3 5.5 4.3c4-1 8 .2 10.5 3.2 2-5.5 6-9.5 12-10.5-4-2.2-9-2.2-12-.2 0-3 2-5.8 5-7-6-2-12-.8-16 2.2L36 4c-1 .5-2.5 2-4 5z"/>');
    },
    pumpkin: function () {
      return svg('0 0 48 46',
        '<path d="M24 10c-.5-4 1.5-7.5 5-9" stroke="#3d6b2a" stroke-width="3" fill="none" stroke-linecap="round"/>' +
        '<ellipse cx="14" cy="28" rx="11" ry="15" fill="#e2701a"/><ellipse cx="34" cy="28" rx="11" ry="15" fill="#e2701a"/>' +
        '<ellipse cx="24" cy="28" rx="11" ry="16" fill="#f58a2a"/>' +
        '<path d="M15 25l4.5-5 4.5 5zM28 25l4.5-5 4.5 5z" fill="#4a2208"/>' +
        '<path d="M14 32q10 8 20 0q-3 1-4 2l-2-2-2 2-2-2-2 2-2-2-2 2q-2-1-4-2z" fill="#4a2208"/>');
    },
    ghost: function () {
      return svg('0 0 40 48',
        '<path d="M20 2C10 2 4 10 4 20v26l6-5 5 5 5-5 5 5 5-5 6 5V20C36 10 30 2 20 2z" fill="#f6f2fb" stroke="#9b8bb4" stroke-width="2"/>' +
        '<ellipse cx="14" cy="20" rx="2.6" ry="3.4" fill="#3a2d4d"/><ellipse cx="26" cy="20" rx="2.6" ry="3.4" fill="#3a2d4d"/>' +
        '<ellipse cx="20" cy="29" rx="3" ry="2" fill="#3a2d4d"/>');
    },
    leaf: function (c) {
      return svg('0 0 40 40',
        '<path d="M20 2C28 10 36 16 34 26 32 34 24 38 20 38 16 38 8 34 6 26 4 16 12 10 20 2z" fill="' + c + '"/>' +
        '<path d="M20 7V38M20 18l-7-5M20 18l7-5M20 27l-9-5M20 27l9-5" stroke="rgba(0,0,0,.22)" stroke-width="1.4" fill="none"/>');
    },
    snow: function (c) {
      return svg('-12 -12 24 24',
        '<g stroke="' + c + '" stroke-width="1.7" stroke-linecap="round" fill="none">' +
        '<path d="M0-10V10M-8.66-5L8.66 5M-8.66 5L8.66-5"/>' +
        '<path d="M-2.5-7.5L0-5 2.5-7.5M-2.5 7.5L0 5 2.5 7.5"/></g>');
    },
    star: function (c) {
      return svg('0 0 24 24', '<path fill="' + c + '" d="M12 0C13 8 16 11 24 12 16 13 13 16 12 24 11 16 8 13 0 12 8 11 11 8 12 0z"/>');
    },
    confetti: function (c) {
      return svg('0 0 8 14', '<rect width="8" height="14" rx="2" fill="' + c + '"/>');
    }
  };

  function pattern(inner, w, h) {
    var s = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '">' + inner + '</svg>';
    return 'url("data:image/svg+xml,' + encodeURIComponent(s) + '")';
  }
  function g(x, y, sc, vbSvg, op) {
    var inner = vbSvg.replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, '');
    return '<g transform="translate(' + x + ' ' + y + ') scale(' + sc + ')" opacity="' + op + '">' + inner + '</g>';
  }

  // ---------- Season settings ----------
  var CFG = {
    halloween: {
      bar: 'linear-gradient(90deg,#2a0f3d 0%,#5b2181 50%,#2a0f3d 100%)',
      pat: pattern(
        g(10, 10, 0.36, ART.bat('#ff8a2a'), 0.85) + g(70, 12, 0.36, ART.pumpkin(), 0.95) +
        g(122, 6, 0.3, ART.bat('#ffb36b'), 0.8) + g(162, 14, 0.34, ART.bat('#ff8a2a'), 0.85), 200, 40),
      scene: 'halloween',
      stripe: 'repeating-linear-gradient(90deg,#f37a1f 0 28px,#1d1029 28px 42px,#8a4bb5 42px 70px,#1d1029 70px 84px)',
      mode: 'flutter',
      sprites: function (i) {
        if (i % 5 === 4) return { html: ART.ghost(), size: 1, kind: 'ghost' };
        if (i % 5 === 2) return { html: ART.pumpkin(), size: 0.9, kind: 'bob' };
        return { html: ART.bat(i % 2 ? '#2b1638' : '#4b2a63'), size: 1.1, kind: 'bat' };
      }
    },
    thanksgiving: {
      bar: 'linear-gradient(90deg,#4a1f08 0%,#9a4317 50%,#4a1f08 100%)',
      pat: pattern(
        g(12, 6, 0.6, ART.leaf('#f2b544'), 0.8) + g(80, 12, 0.5, ART.leaf('#e8692a'), 0.8) +
        g(140, 4, 0.55, ART.leaf('#ffd27a'), 0.75), 200, 40),
      scene: 'thanksgiving',
      stripe: 'repeating-linear-gradient(90deg,#b5541c 0 30px,#e2a03f 30px 60px,#7a3b17 60px 90px,#c98a2c 90px 120px)',
      mode: 'fall',
      sprites: function (i) {
        var c = ['#c8551d', '#e2a03f', '#a33b1a', '#d97a26', '#8c5a1e'][i % 5];
        return { html: ART.leaf(c), size: 0.9, kind: 'leaf' };
      }
    },
    christmas: {
      bar: 'linear-gradient(90deg,#0d4a2e 0%,#b0122c 50%,#0d4a2e 100%)',
      pat: pattern(
        g(16, 12, 0.9, ART.snow('#ffffff'), 0.7) + g(90, 26, 0.6, ART.snow('#ffffff'), 0.6) +
        g(150, 10, 0.75, ART.snow('#ffffff'), 0.65), 200, 40),
      scene: 'christmas',
      stripe: 'repeating-linear-gradient(135deg,#c8102e 0 10px,#ffffff 10px 20px,#1f7a45 20px 30px,#ffffff 30px 40px)',
      mode: 'fall',
      sprites: function (i) {
        return { html: ART.snow(['#8fbfe3', '#b9d8ee', '#6fa9d6'][i % 3]), size: 0.75 + (i % 3) * 0.2, kind: 'snow' };
      }
    },
    newyear: {
      bar: 'linear-gradient(90deg,#0b1026 0%,#2e2a78 50%,#0b1026 100%)',
      pat: pattern(
        g(14, 8, 0.6, ART.star('#f3d46b'), 0.9) + g(84, 22, 0.4, ART.star('#ffffff'), 0.8) +
        g(146, 6, 0.5, ART.star('#f3d46b'), 0.85), 200, 40),
      scene: 'newyear',
      stripe: 'linear-gradient(90deg,#b8901f,#f3dd8d,#b8901f,#f3dd8d,#b8901f)',
      mode: 'fall',
      sprites: function (i) {
        if (i % 4 === 3) return { html: ART.star('#d9b13b'), size: 0.8, kind: 'twinkle' };
        var c = ['#d9b13b', '#c0c0c8', '#e05a8a', '#3a7bd5', '#2bb39a'][i % 5];
        return { html: ART.confetti(c), size: 0.4, kind: 'confetti' };
      }
    }
  };
  var cfg = CFG[season];

  // ---------- Styles ----------
  var css = '' +
    'html.llc-season .utility-bar{background:' + cfg.pat + ' center/200px 40px repeat-x,' + cfg.bar + ' !important}' +
    'html.llc-season .utility-bar *{text-shadow:0 1px 2px rgba(0,0,0,.45)}' +
    'html.llc-season .header-wrapper--border-bottom{border-bottom-color:transparent !important}' +
    'html.llc-season .header-wrapper{position:relative}' +
    'html.llc-season .header-wrapper::after{content:"";position:absolute;left:0;right:0;bottom:-1px;height:5px;background:' + cfg.stripe + ';pointer-events:none;z-index:1}' +
    'html.llc-season .llc-hero{isolation:isolate}' +
    'html.llc-season .llc-hero-bg{z-index:-1}' +
    '.llc-bubble.llc-bubble--season{background:none !important;border:0 !important;box-shadow:none !important;border-radius:0 !important;opacity:.85 !important}' +
    '.llc-bubble.llc-bubble--hide{visibility:hidden !important}' +
    '.llc-bubble--season svg{display:block;width:100%;height:100%}' +
    '.llc-scene{position:absolute;pointer-events:none}' +
    '.llc-scene svg{display:block;width:100%;height:100%}' +
    '.llc-scene--moon{top:14px;right:3%;width:clamp(56px,9vw,120px);height:clamp(56px,9vw,120px);opacity:.9}' +
    '.llc-scene--ground{left:0;right:0;bottom:0;height:clamp(46px,6vw,78px)}' +
    '.llc-gutter{position:fixed;top:0;bottom:110px;pointer-events:none;z-index:2;overflow:hidden;contain:strict}' +
    '.llc-gutter *{pointer-events:none}' +
    '.llc-gutter--left{left:0}.llc-gutter--right{right:0}' +
    '.llc-item{position:absolute;will-change:transform}' +
    '.llc-item svg{display:block;width:100%;height:100%}' +
    '.llc-inner{width:100%;height:100%}' +
    '@keyframes llc-drift{0%{transform:translate(0,0)}50%{transform:translate(var(--dx),var(--dy))}100%{transform:translate(calc(var(--dx)*-.6),calc(var(--dy)*.5))}}' +
    '@keyframes llc-flap{from{transform:scaleY(1)}to{transform:scaleY(.5)}}' +
    '@keyframes llc-bob{from{transform:translateY(0)}to{transform:translateY(-10px)}}' +
    '@keyframes llc-fall{from{transform:translateY(-60px)}to{transform:translateY(var(--fall))}}' +
    '@keyframes llc-sway{0%{transform:translateX(0) rotate(0)}50%{transform:translateX(var(--sx)) rotate(var(--rot))}100%{transform:translateX(0) rotate(0)}}' +
    '@keyframes llc-twinkle{0%,100%{opacity:.25;transform:scale(.6)}50%{opacity:1;transform:scale(1.1)}}' +
    '@media (prefers-reduced-motion:reduce){.llc-gutter{display:none}}';

  var style = document.createElement('style');
  style.id = 'llc-season-style';
  style.textContent = css;
  document.head.appendChild(style);
  document.documentElement.classList.add('llc-season', 'llc-season--' + season);


  // ---------- Hero scene (all screen sizes) ----------
  var MOON = {
    halloween: svg('0 0 100 100', '<circle cx="50" cy="50" r="40" fill="#fff4cf"/><circle cx="38" cy="40" r="6" fill="#efe0a8"/><circle cx="60" cy="62" r="9" fill="#efe0a8"/><circle cx="62" cy="34" r="4" fill="#efe0a8"/>' + '<g transform="translate(8 58) scale(.5)">' + ART.bat('#2b1638').replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g>'),
    thanksgiving: svg('0 0 100 100', '<circle cx="50" cy="50" r="40" fill="#ffd27a" opacity=".85"/><circle cx="50" cy="50" r="30" fill="#ffc04d" opacity=".7"/>'),
    christmas: svg('0 0 100 100', '<path d="M50 6l11 25 27 3-20 18 6 27-24-14-24 14 6-27-20-18 27-3z" fill="#f3c63f"/>'),
    newyear: svg('0 0 100 100', '<g stroke="#e0b53a" stroke-width="3" stroke-linecap="round"><path d="M50 50V8M50 50l30-30M50 50h42M50 50l30 30M50 50V92M50 50L20 80M50 50H8M50 50L20 20"/></g><g fill="#e05a8a"><circle cx="50" cy="8" r="4"/><circle cx="92" cy="50" r="4"/><circle cx="50" cy="92" r="4"/><circle cx="8" cy="50" r="4"/></g><g fill="#3a7bd5"><circle cx="80" cy="20" r="4"/><circle cx="80" cy="80" r="4"/><circle cx="20" cy="80" r="4"/><circle cx="20" cy="20" r="4"/></g>')
  };

  function groundSvg(kind) {
    var w = 1200, h = 80, out = '';
    function at(x, y, sc, art) { return '<g transform="translate(' + x + ' ' + y + ') scale(' + sc + ')">' + art.replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g>'; }
    if (kind === 'halloween') {
      out += '<path d="M0 70 Q300 52 600 66 T1200 62 V80 H0z" fill="#2b1638" opacity=".9"/>';
      [40, 210, 520, 830, 1080].forEach(function (x, i) { out += at(x, 22 + (i % 2) * 6, 1 - (i % 2) * 0.2, ART.pumpkin()); });
      [140, 680, 960].forEach(function (x) { out += '<path d="M' + x + ' 72 v-34 l4 -6 4 6 v34" fill="#2b1638"/>'; });
      out += at(380, 30, 0.8, ART.ghost());
    } else if (kind === 'thanksgiving') {
      out += '<path d="M0 70 Q300 56 600 68 T1200 64 V80 H0z" fill="#8a4a1c" opacity=".85"/>';
      var cols = ['#c8551d', '#e2a03f', '#a33b1a', '#d97a26', '#f2b544'];
      for (var i = 0; i < 26; i++) out += '<g transform="translate(' + (i * 47 + (i % 3) * 9) + ' ' + (44 + (i % 4) * 5) + ') rotate(' + ((i * 47) % 360) + ' 12 12) scale(.62)">' + ART.leaf(cols[i % 5]).replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g>';
    } else if (kind === 'christmas') {
      out += '<path d="M0 60 Q150 44 300 58 T600 54 T900 58 T1200 52 V80 H0z" fill="#ffffff"/><path d="M0 60 Q150 44 300 58 T600 54 T900 58 T1200 52" fill="none" stroke="#d6e7f3" stroke-width="3"/>';
      [90, 470, 1010].forEach(function (x, i) { var s = 1 - i * 0.12; out += '<g transform="translate(' + x + ' 6) scale(' + s + ')"><path d="M24 0l14 22h-7l13 20h-8l14 20H2l14-20H8l13-20h-7z" fill="#1f7a45"/><rect x="20" y="62" width="8" height="8" fill="#6b3a1e"/><circle cx="18" cy="30" r="2.5" fill="#c8102e"/><circle cx="30" cy="44" r="2.5" fill="#f3c63f"/><circle cx="16" cy="52" r="2.5" fill="#3a7bd5"/></g>'; });
    } else {
      var c2 = ['#d9b13b', '#e05a8a', '#3a7bd5', '#2bb39a', '#c0c0c8'];
      for (var j = 0; j < 60; j++) out += '<rect x="' + ((j * 97) % 1200) + '" y="' + (20 + (j * 37) % 55) + '" width="6" height="11" rx="1.5" fill="' + c2[j % 5] + '" transform="rotate(' + ((j * 53) % 180) + ' ' + ((j * 97) % 1200) + ' ' + (20 + (j * 37) % 55) + ')"/>';
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '" preserveAspectRatio="xMidYMax slice" aria-hidden="true">' + out + '</svg>';
  }

  // ---------- Heavy Halloween hero: full night scene (Tesla-style) ----------
  function hauntedSvg() {
    var seed = 7;
    function rnd() { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }
    function f(n) { return Math.round(n * 10) / 10; }
    var o = [];
    // defs
    o.push('<defs>' +
      '<linearGradient id="hs-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0b0a1e"/><stop offset=".55" stop-color="#241a44"/><stop offset=".8" stop-color="#43305f"/><stop offset="1" stop-color="#2a1d3e"/></linearGradient>' +
      '<radialGradient id="hs-mglow"><stop offset="0" stop-color="#fff3c4" stop-opacity=".55"/><stop offset=".35" stop-color="#ffe9a8" stop-opacity=".18"/><stop offset="1" stop-color="#ffe9a8" stop-opacity="0"/></radialGradient>' +
      '<radialGradient id="hs-moon" cx=".4" cy=".4"><stop offset="0" stop-color="#fffdf0"/><stop offset=".7" stop-color="#f6e7b4"/><stop offset="1" stop-color="#e3cf8c"/></radialGradient>' +
      '<radialGradient id="hs-pglow"><stop offset="0" stop-color="#ff9a2a" stop-opacity=".75"/><stop offset=".4" stop-color="#ff7a1a" stop-opacity=".25"/><stop offset="1" stop-color="#ff6a00" stop-opacity="0"/></radialGradient>' +
      '<radialGradient id="hs-fire" cx=".5" cy=".6"><stop offset="0" stop-color="#fff6b0"/><stop offset=".5" stop-color="#ffc23d"/><stop offset="1" stop-color="#ff7a00"/></radialGradient>' +
      '<radialGradient id="hs-pbody" cx=".4" cy=".35"><stop offset="0" stop-color="#ff9a3c"/><stop offset=".7" stop-color="#e2620f"/><stop offset="1" stop-color="#9c3c06"/></radialGradient>' +
      '<linearGradient id="hs-win" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe08a"/><stop offset="1" stop-color="#ff9a2a"/></linearGradient>' +
      '<linearGradient id="hs-stone" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#6e6888"/><stop offset="1" stop-color="#3a354f"/></linearGradient>' +
      '<filter id="hs-blur" x="-20%" y="-50%" width="140%" height="200%"><feGaussianBlur stdDeviation="14"/></filter>' +
      '</defs>');
    o.push('<rect width="1600" height="900" fill="url(#hs-sky)"/>');
    // stars
    for (var i = 0; i < 80; i++) {
      var sx = f(rnd() * 1600), sy = f(rnd() * 470), sr = f(0.6 + rnd() * 1.4);
      o.push('<circle cx="' + sx + '" cy="' + sy + '" r="' + sr + '" fill="#fff" opacity="' + f(0.3 + rnd() * 0.6) + '">' +
        (i % 6 === 0 ? '<animate attributeName="opacity" values=".2;1;.2" dur="' + f(2 + rnd() * 3) + 's" repeatCount="indefinite"/>' : '') + '</circle>');
    }
    // moon + glow + craters
    o.push('<circle cx="820" cy="300" r="260" fill="url(#hs-mglow)"/>');
    o.push('<circle cx="820" cy="300" r="84" fill="url(#hs-moon)"/>');
    o.push('<g fill="#e0cd8f" opacity=".7"><circle cx="795" cy="280" r="13"/><circle cx="845" cy="325" r="18"/><circle cx="850" cy="270" r="7"/><circle cx="785" cy="330" r="6"/></g>');
    // clouds drifting over moon
    o.push('<g opacity=".75"><path d="M630 280 q40 -26 90 -8 q30 -24 80 -6 q50 -10 70 16 q-60 12 -240 -2z" fill="#2a2045"><animateTransform attributeName="transform" type="translate" values="-60 0;90 0;-60 0" dur="38s" repeatCount="indefinite"/></path>' +
      '<path d="M770 360 q50 -20 100 -4 q40 -18 90 4 q-90 14 -190 0z" fill="#33285a"><animateTransform attributeName="transform" type="translate" values="40 0;-80 0;40 0" dur="30s" repeatCount="indefinite"/></path></g>');
    // bats crossing the moon
    var batD = 'M32 9c-1.5-3-3-4.5-4-5l-1 4.5c-4-3-10-4.2-16-2.2 3 1.2 5 4 5 7-3-2-8-2-12 .2 6 1 10 5 12 10.5 2.5-3 6.5-4.2 10.5-3.2 1-3 3.5-4.3 5.5-4.3s4.5 1.3 5.5 4.3c4-1 8 .2 10.5 3.2 2-5.5 6-9.5 12-10.5-4-2.2-9-2.2-12-.2 0-3 2-5.8 5-7-6-2-12-.8-16 2.2L36 4c-1 .5-2.5 2-4 5z';
    [[550, 250, 1110, 170, 16, 1.6], [490, 330, 1090, 270, 21, 1.1], [610, 200, 1170, 230, 25, 1.3]].forEach(function (b, k) {
      o.push('<g><animateTransform attributeName="transform" type="translate" values="' + b[0] + ' ' + b[1] + ';' + b[2] + ' ' + b[3] + '" dur="' + b[4] + 's" begin="-' + (k * 5) + 's" repeatCount="indefinite"/>' +
        '<g transform="scale(' + b[5] + ')"><path d="' + batD + '" fill="#120c1f"><animateTransform attributeName="transform" type="scale" values="1 1;1 .45;1 1" dur=".35s" repeatCount="indefinite" additive="sum"/></path></g></g>');
    });
    // distant hills
    o.push('<path d="M0 690 Q200 610 420 650 T860 630 T1300 660 T1600 640 V900 H0Z" fill="#1d1533"/>');
    // dead-tree generator
    function tree(x, y, len, w, depth, col) {
      var parts = [];
      (function br(x0, y0, l, ang, wd, d) {
        if (d === 0 || l < 5) return;
        var ex = x0 + l * Math.sin(ang), ey = y0 - l * Math.cos(ang);
        var cx = (x0 + ex) / 2 + (rnd() - 0.5) * l * 0.35, cy = (y0 + ey) / 2 + (rnd() - 0.5) * l * 0.2;
        parts.push('<path d="M' + f(x0) + ' ' + f(y0) + 'Q' + f(cx) + ' ' + f(cy) + ' ' + f(ex) + ' ' + f(ey) + '" stroke-width="' + f(Math.max(1, wd)) + '"/>');
        var n = d > 4 ? 2 : (rnd() < 0.5 ? 2 : 3);
        for (var c = 0; c < n; c++) br(ex, ey, l * (0.62 + rnd() * 0.16), ang + (c - (n - 1) / 2) * 0.62 + (rnd() - 0.5) * 0.5, wd * 0.62, d - 1);
      })(x, y, len, (rnd() - 0.5) * 0.15, w, depth);
      return '<g stroke="' + col + '" fill="none" stroke-linecap="round">' + parts.join('') + '</g>';
    }
    o.push(tree(1555, 655, 110, 16, 6, '#150f24'));
    o.push(tree(690, 735, 70, 9, 5, '#1a1330'));
    // haunted house on its hill
    o.push('<path d="M880 900 V790 Q980 760 1060 700 Q1180 612 1320 634 Q1460 652 1600 604 V900Z" fill="#160f26"/>');
    var H = '#100b1c';
    o.push('<g fill="' + H + '">' +
      '<rect x="1210" y="480" width="230" height="160"/><polygon points="1192,482 1325,392 1458,482"/>' +
      '<rect x="1163" y="410" width="72" height="230"/><polygon points="1152,412 1199,296 1246,412"/><rect x="1197" y="270" width="3" height="30"/>' +
      '<rect x="1440" y="540" width="82" height="100"/><polygon points="1430,542 1481,502 1532,542"/>' +
      '<rect x="1383" y="408" width="22" height="62" transform="rotate(7 1394 440)"/>' +
      '<polygon points="1300,640 1350,640 1360,652 1290,652"/></g>');
    function win(x, y, w, h, flick, arch) {
      var shape = arch ? '<path d="M' + x + ' ' + (y + h) + 'V' + (y + w / 2) + 'a' + (w / 2) + ' ' + (w / 2) + ' 0 0 1 ' + w + ' 0V' + (y + h) + 'z"' : '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '"';
      return shape + ' fill="url(#hs-win)">' + (flick ? '<animate attributeName="opacity" values="1;.55;1;.85;1" dur="' + flick + 's" repeatCount="indefinite"/>' : '') + (arch ? '</path>' : '</rect>') +
        '<path d="M' + (x + w / 2) + ' ' + (y + (arch ? w / 2 : 0)) + 'V' + (y + h) + 'M' + x + ' ' + (y + h * 0.55) + 'H' + (x + w) + '" stroke="' + H + '" stroke-width="2.5"/>';
    }
    o.push('<g>' + win(1240, 505, 30, 40, 0, false) + win(1290, 505, 30, 40, 3.1, false) + win(1380, 505, 30, 40, 0, false) +
      win(1240, 575, 30, 40, 2.3, false) + win(1380, 575, 30, 40, 0, false) + win(1187, 440, 24, 36, 4.2, true) + win(1187, 505, 24, 36, 0, true) +
      win(1466, 566, 26, 32, 2.7, false) + '<circle cx="1325" cy="450" r="11" fill="url(#hs-win)"/>' +
      '<path d="M1309 640V598a16 16 0 0 1 32 0V640z" fill="#ffb347" opacity=".85"/>' +
      '<rect x="1340" y="505" width="30" height="40" fill="#0b0814"/></g>');
    // iron fence
    var fence = '<g stroke="#0c0916" stroke-width="3" fill="#0c0916">';
    for (var px = 380; px <= 1040; px += 26) fence += '<path d="M' + px + ' 772V722"/><path d="M' + (px - 4) + ' 724l4 -9 4 9z" stroke="none"/>';
    fence += '<path d="M370 732H1050M370 762H1050" stroke-width="3.5"/></g>';
    o.push(fence);
    // ground
    o.push('<path d="M0 775 Q300 748 600 772 T1200 768 T1600 758 V900 H0Z" fill="#0f0b19"/>');
    // tombstones
    function tomb(x, y, s, rot, kind) {
      var g = '<g transform="translate(' + x + ' ' + y + ') rotate(' + rot + ') scale(' + s + ')">';
      if (kind === 'cross') g += '<rect x="-7" y="-78" width="14" height="78" fill="url(#hs-stone)"/><rect x="-26" y="-60" width="52" height="13" fill="url(#hs-stone)"/>';
      else if (kind === 'square') g += '<path d="M-24 0V-58H24V0Z" fill="url(#hs-stone)"/><path d="M-24 -58H24" stroke="#8a84a6" stroke-width="2"/>';
      else g += '<path d="M-26 0V-46Q-26 -72 0 -72Q26 -72 26 -46V0Z" fill="url(#hs-stone)"/><text x="0" y="-36" text-anchor="middle" font-family="Georgia,serif" font-size="15" font-weight="700" fill="#2a2640">RIP</text>';
      return g + '<path d="M-30 1H30" stroke="#0f0b19" stroke-width="5"/></g>';
    }
    o.push(tomb(300, 812, 1.25, -6, 'round') + tomb(440, 800, 0.9, 5, 'cross') + tomb(590, 818, 1.1, -3, 'round') +
      tomb(740, 806, 0.8, 8, 'square') + tomb(960, 820, 1.05, -5, 'round') + tomb(1120, 812, 0.85, 4, 'cross'));
    // zombie hand
    o.push('<g fill="#5b7a3f" stroke="#2f4220" stroke-width="1.5"><path d="M860 862 l4 -36 l10 -2 l3 38z"/>' +
      '<path d="M861 830 l-9 -16 l5 -3 l9 14z"/><path d="M866 826 l-3 -22 l6 -1 l3 22z"/><path d="M872 826 l3 -21 l6 1 l-3 21z"/><path d="M876 830 l8 -15 l5 3 l-7 15z"/></g>');
    // left big dead tree (in front)
    o.push(tree(110, 895, 175, 30, 7, '#0a0712'));
    // jack-o'-lanterns with glow + flicker
    function jack(x, y, s) {
      var d = f(1.4 + rnd() * 1.6);
      return '<g transform="translate(' + x + ' ' + y + ') scale(' + s + ')">' +
        '<circle cx="0" cy="-8" r="95" fill="url(#hs-pglow)"><animate attributeName="opacity" values=".9;.55;1;.7;.9" dur="' + d + 's" repeatCount="indefinite"/></circle>' +
        '<path d="M-2 -46q-2 -14 10 -20" stroke="#3d5a1e" stroke-width="6" fill="none" stroke-linecap="round"/>' +
        '<ellipse cx="-22" cy="-12" rx="22" ry="32" fill="url(#hs-pbody)"/><ellipse cx="22" cy="-12" rx="22" ry="32" fill="url(#hs-pbody)"/><ellipse cx="0" cy="-12" rx="22" ry="35" fill="url(#hs-pbody)"/>' +
        '<g fill="url(#hs-fire)"><path d="M-24 -20l9 -14 9 14z"/><path d="M6 -20l9 -14 9 14z"/><path d="M-3 -10l3 -7 3 7z"/>' +
        '<path d="M-26 0q26 22 52 0l-6 4-5-5-6 6-5-6-5 6-6-6-5 5-6-4z"/><animate attributeName="opacity" values="1;.75;1;.85;1" dur="' + d + 's" repeatCount="indefinite"/></g></g>';
    }
    [[70, 880, 1.25], [430, 878, 0.95], [520, 892, 0.7], [1040, 880, 1.15], [1190, 892, 0.8], [1520, 875, 1.3], [780, 895, 0.65]].forEach(function (p) { o.push(jack(p[0], p[1], p[2])); });
    // drifting fog
    o.push('<g filter="url(#hs-blur)" fill="#d9d2f2"><ellipse cx="500" cy="800" rx="520" ry="34" opacity=".14"><animateTransform attributeName="transform" type="translate" values="-80 0;80 0;-80 0" dur="26s" repeatCount="indefinite"/></ellipse>' +
      '<ellipse cx="1150" cy="840" rx="560" ry="40" opacity=".12"><animateTransform attributeName="transform" type="translate" values="60 0;-90 0;60 0" dur="32s" repeatCount="indefinite"/></ellipse>' +
      '<ellipse cx="800" cy="890" rx="900" ry="30" opacity=".16"/></g>');
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMax slice" aria-hidden="true">' + o.join('') + '</svg>';
  }

  // ---------- Thanksgiving, Christmas, New Year's full scenes ----------
  function sceneKit(seedStart) {
    var seed = seedStart;
    var k = {};
    k.rnd = function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; };
    k.f = function (n) { return Math.round(n * 10) / 10; };
    k.stars = function (n, maxY) {
      var s = '';
      for (var i = 0; i < n; i++) {
        s += '<circle cx="' + k.f(k.rnd() * 1600) + '" cy="' + k.f(k.rnd() * maxY) + '" r="' + k.f(0.6 + k.rnd() * 1.3) + '" fill="#fff" opacity="' + k.f(0.3 + k.rnd() * 0.6) + '">' +
          (i % 6 === 0 ? '<animate attributeName="opacity" values=".2;1;.2" dur="' + k.f(2 + k.rnd() * 3) + 's" repeatCount="indefinite"/>' : '') + '</circle>';
      }
      return s;
    };
    // something falling from the sky, swaying (leaves, snow, confetti)
    k.fall = function (n, art, x0, x1, dmin, dmax, spin) {
      var s = '';
      for (var i = 0; i < n; i++) {
        var x = k.f(x0 + k.rnd() * (x1 - x0)), dur = k.f(dmin + k.rnd() * (dmax - dmin)), dx = k.f((k.rnd() - 0.5) * 160);
        s += '<g><animateTransform attributeName="transform" type="translate" values="' + x + ' -40;' + k.f(x + dx) + ' 940" dur="' + dur + 's" begin="-' + k.f(k.rnd() * dur) + 's" repeatCount="indefinite"/>' +
          '<g>' + (spin ? '<animateTransform attributeName="transform" type="rotate" values="0;' + (k.rnd() < 0.5 ? 360 : -360) + '" dur="' + k.f(3 + k.rnd() * 4) + 's" repeatCount="indefinite"/>' : '') + art(i) + '</g></g>';
      }
      return s;
    };
    k.svg = function (defs, body) {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMax slice" aria-hidden="true"><defs>' + defs + '</defs>' + body + '</svg>';
    };
    k.glowDef = function (id, color, a) { return '<radialGradient id="' + id + '"><stop offset="0" stop-color="' + color + '" stop-opacity="' + a + '"/><stop offset=".4" stop-color="' + color + '" stop-opacity="' + (a / 3) + '"/><stop offset="1" stop-color="' + color + '" stop-opacity="0"/></radialGradient>'; };
    k.blur = '<filter id="sc-blur" x="-20%" y="-50%" width="140%" height="200%"><feGaussianBlur stdDeviation="14"/></filter>';
    return k;
  }

  function thanksgivingSvg() {
    var k = sceneKit(11), f = k.f, rnd = k.rnd, o = [];
    var defs = '<linearGradient id="tg-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#1c1836"/><stop offset=".42" stop-color="#4b2547"/><stop offset=".68" stop-color="#a8432f"/><stop offset=".86" stop-color="#e57f35"/><stop offset="1" stop-color="#f3b05a"/></linearGradient>' +
      k.glowDef('tg-mglow', '#ffcf7a', 0.55) +
      '<radialGradient id="tg-moon" cx=".4" cy=".4"><stop offset="0" stop-color="#ffe7b0"/><stop offset=".75" stop-color="#ffb860"/><stop offset="1" stop-color="#f08f3a"/></radialGradient>' +
      '<radialGradient id="tg-pump" cx=".4" cy=".35"><stop offset="0" stop-color="#ffa54a"/><stop offset=".75" stop-color="#e2700f"/><stop offset="1" stop-color="#a84a08"/></radialGradient>' +
      '<linearGradient id="tg-hay" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f2c55c"/><stop offset="1" stop-color="#b98429"/></linearGradient>' +
      '<linearGradient id="tg-ground" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#4a2814"/><stop offset="1" stop-color="#2a150a"/></linearGradient>' +
      k.glowDef('tg-win', '#ffd27a', 0.8) + k.blur;
    o.push('<rect width="1600" height="900" fill="url(#tg-sky)"/>');
    o.push(k.stars(40, 300));
    // harvest moon
    o.push('<circle cx="820" cy="300" r="250" fill="url(#tg-mglow)"/><circle cx="820" cy="300" r="88" fill="url(#tg-moon)"/>' +
      '<g fill="#f0a24f" opacity=".55"><circle cx="795" cy="280" r="12"/><circle cx="848" cy="322" r="16"/><circle cx="852" cy="268" r="6"/></g>');
    // birds flying south
    var bird = 'M0 0q8 -7 16 0q8 -7 16 0q-8 -3 -16 3q-8 -6 -16 -3z';
    [[520, 210, 1250, 150, 26], [470, 240, 1200, 180, 26], [570, 245, 1300, 185, 26]].forEach(function (b, i) {
      o.push('<g><animateTransform attributeName="transform" type="translate" values="' + b[0] + ' ' + b[1] + ';' + b[2] + ' ' + b[3] + '" dur="' + b[4] + 's" begin="-' + (i * 0.6) + 's" repeatCount="indefinite"/><path d="' + bird + '" fill="#2a1424"/></g>');
    });
    // layered hills
    o.push('<path d="M0 640 Q220 560 460 610 T920 590 T1360 620 T1600 600 V900 H0Z" fill="#7a3324"/>');
    o.push('<path d="M0 700 Q260 650 520 690 T1040 680 T1600 650 V900 H0Z" fill="#5a2418"/>');
    // barn + silo on the right hill
    o.push('<path d="M900 900 V780 Q1040 690 1200 676 Q1400 660 1600 640 V900Z" fill="#4a1e12"/>');
    o.push('<g><rect x="1490" y="500" width="62" height="190" fill="#9aa3ad"/><path d="M1490 500a31 26 0 0 1 62 0z" fill="#6f7884"/>' +
      '<path d="M1490 540H1552M1490 580H1552M1490 620H1552M1490 660H1552" stroke="#7d8692" stroke-width="2"/></g>');
    o.push('<g><rect x="1230" y="560" width="250" height="130" fill="#9c2218"/><polygon points="1215,562 1265,490 1445,490 1495,562" fill="#3b1410"/>' +
      '<path d="M1230 560H1480" stroke="#f3e6d6" stroke-width="5"/>' +
      '<rect x="1318" y="600" width="74" height="90" fill="#5a120c"/><path d="M1318 600l74 90M1392 600l-74 90M1318 600h74v90h-74z" stroke="#f3e6d6" stroke-width="5" fill="none"/>' +
      '<rect x="1336" y="512" width="38" height="34" fill="#ffd27a"><animate attributeName="opacity" values="1;.8;1" dur="3s" repeatCount="indefinite"/></rect><path d="M1336 512h38v34h-38zM1355 512v34" stroke="#f3e6d6" stroke-width="3" fill="none"/>' +
      '<rect x="1250" y="600" width="44" height="34" fill="#ffd27a"/><rect x="1416" y="600" width="44" height="34" fill="#ffd27a"/>' +
      '<path d="M1250 600h44v34h-44zM1416 600h44v34h-44z" stroke="#f3e6d6" stroke-width="3" fill="none"/></g>');
    // autumn tree helper: trunk branches with foliage clusters
    function fallTree(x, y, h, scale) {
      var s = '<g transform="translate(' + x + ' ' + y + ') scale(' + scale + ')">';
      s += '<path d="M-12 0 Q-8 -' + (h * 0.5) + ' -4 -' + h + ' L4 -' + h + ' Q8 -' + (h * 0.5) + ' 12 0z" fill="#3a2214"/>';
      s += '<path d="M0 -' + (h * 0.55) + 'q-40 -30 -70 -40M0 -' + (h * 0.7) + 'q40 -25 75 -30M0 -' + (h * 0.85) + 'q-25 -20 -45 -45" stroke="#3a2214" stroke-width="7" fill="none" stroke-linecap="round"/>';
      var cols = ['#c2381a', '#e0601f', '#f0902c', '#f6b746', '#a82c16'];
      for (var i = 0; i < 26; i++) {
        var a = rnd() * Math.PI * 2, r = rnd() * 95;
        s += '<circle cx="' + f(Math.cos(a) * r * 1.15) + '" cy="' + f(-h - 20 + Math.sin(a) * r * 0.8) + '" r="' + f(26 + rnd() * 26) + '" fill="' + cols[i % 5] + '" opacity=".95"/>';
      }
      return s + '</g>';
    }
    o.push(fallTree(690, 720, 120, 0.7));
    // wooden fence
    var fence = '<g stroke="#5b3720" stroke-width="7" stroke-linecap="round">';
    for (var px = 360; px <= 1060; px += 70) fence += '<path d="M' + px + ' 790V735"/>';
    fence += '<path d="M350 750H1070M350 775H1070" stroke-width="6"/></g>';
    o.push(fence);
    // ground
    o.push('<path d="M0 778 Q300 752 600 774 T1200 770 T1600 760 V900 H0Z" fill="url(#tg-ground)"/>');
    // corn shocks
    function shock(x, y, s) {
      var g = '<g transform="translate(' + x + ' ' + y + ') scale(' + s + ')" stroke-linecap="round">';
      for (var i = -6; i <= 6; i++) g += '<path d="M' + (i * 3) + ' -20 L' + (i * 9) + ' 0" stroke="#c99a3e" stroke-width="4"/><path d="M' + (i * 3) + ' -20 L' + (i * 2) + ' -' + (120 + (i % 3) * 8) + '" stroke="' + (i % 2 ? '#d8ad4f' : '#b8862f') + '" stroke-width="4"/>';
      return g + '<path d="M-22 -30H22" stroke="#7a4b22" stroke-width="6"/></g>';
    }
    o.push(shock(470, 812, 1) + shock(1150, 806, 0.9));
    // hay bales
    function hay(x, y, s) {
      return '<g transform="translate(' + x + ' ' + y + ') scale(' + s + ')"><rect x="-60" y="-56" width="120" height="56" rx="10" fill="url(#tg-hay)"/>' +
        '<path d="M-60 -38H60M-60 -20H60M-30 -56V0M30 -56V0" stroke="#a87523" stroke-width="3" opacity=".6"/></g>';
    }
    o.push(hay(300, 830, 1.1) + hay(380, 845, 0.8) + hay(1060, 840, 0.95));
    // scarecrow
    o.push('<g transform="translate(960 812)"><path d="M0 0V-150M-70 -110H70" stroke="#6b4423" stroke-width="8" stroke-linecap="round"/>' +
      '<path d="M-58 -118 L58 -118 L44 -60 L-44 -60z" fill="#3d6aa8"/><path d="M-20 -118L-14 -60M18 -118L14 -60" stroke="#2c4f80" stroke-width="3"/>' +
      '<rect x="-30" y="-62" width="60" height="40" fill="#7a5130"/><path d="M-70 -118l-10 8 6 2 -8 6M70 -118l10 8 -6 2 8 6" stroke="#e2b552" stroke-width="3" fill="none"/>' +
      '<circle cx="0" cy="-150" r="22" fill="#e9cf9a"/><circle cx="-7" cy="-153" r="2.5" fill="#2a1a10"/><circle cx="7" cy="-153" r="2.5" fill="#2a1a10"/><path d="M-8 -141q8 5 16 0" stroke="#2a1a10" stroke-width="2" fill="none"/>' +
      '<path d="M-38 -166H38L22 -170 18 -196H-18L-22 -170z" fill="#6b4423"/><path d="M-20 -172H20" stroke="#c2381a" stroke-width="4"/></g>');
    // turkey
    o.push('<g transform="translate(700 840)">' +
      ['#7a3b17', '#c2381a', '#e0601f', '#f6b746', '#7a3b17', '#c2381a', '#e0601f'].map(function (c, i) {
        return '<ellipse cx="0" cy="-55" rx="12" ry="48" fill="' + c + '" transform="rotate(' + (-72 + i * 24) + ' 0 -12)"/>';
      }).join('') +
      '<ellipse cx="0" cy="-22" rx="30" ry="26" fill="#5a3320"/><path d="M14 -40 q14 -16 8 -38" stroke="#5a3320" stroke-width="10" fill="none" stroke-linecap="round"/>' +
      '<circle cx="22" cy="-80" r="10" fill="#6b4028"/><path d="M30 -80l9 3 -9 3z" fill="#f2b544"/><path d="M28 -74q4 10 -2 14" stroke="#c8102e" stroke-width="5" fill="none" stroke-linecap="round"/><circle cx="24" cy="-83" r="2" fill="#111"/>' +
      '<path d="M-8 2v10M8 2v10" stroke="#e0a030" stroke-width="3"/></g>');
    // pumpkins + gourds (uncarved)
    function pumpkin(x, y, s) {
      return '<g transform="translate(' + x + ' ' + y + ') scale(' + s + ')"><path d="M-2 -44q-2 -14 10 -20" stroke="#3d5a1e" stroke-width="6" fill="none" stroke-linecap="round"/>' +
        '<ellipse cx="-22" cy="-14" rx="22" ry="30" fill="url(#tg-pump)"/><ellipse cx="22" cy="-14" rx="22" ry="30" fill="url(#tg-pump)"/><ellipse cx="0" cy="-14" rx="22" ry="33" fill="url(#tg-pump)"/></g>';
    }
    [[90, 880, 1.2], [180, 892, 0.8], [560, 888, 0.9], [830, 892, 0.7], [1250, 885, 1.1], [1340, 895, 0.75], [1520, 880, 1.25]].forEach(function (p) { o.push(pumpkin(p[0], p[1], p[2])); });
    // big autumn tree on the left (foreground)
    o.push(fallTree(110, 900, 200, 0.75));
    // falling leaves
    var lc = ['#c2381a', '#e0601f', '#f0902c', '#f6b746', '#a82c16'];
    o.push(k.fall(22, function (i) { return '<path d="M0 -12C6 -6 12 -2 11 6 9 12 3 14 0 14-3 14-9 12-11 6-12-2-6-6 0-12z" fill="' + lc[i % 5] + '"/>'; }, 0, 1600, 12, 22, true));
    // low warm haze
    o.push('<g filter="url(#sc-blur)" fill="#ffcf8a"><ellipse cx="800" cy="890" rx="900" ry="30" opacity=".18"/></g>');
    return k.svg(defs, o.join(''));
  }

  function christmasSvg() {
    var k = sceneKit(23), f = k.f, rnd = k.rnd, o = [];
    var defs = '<linearGradient id="xm-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#050f26"/><stop offset=".55" stop-color="#112b55"/><stop offset="1" stop-color="#2b4e82"/></linearGradient>' +
      k.glowDef('xm-mglow', '#e8f1ff', 0.45) + k.glowDef('xm-warm', '#ffd27a', 0.7) +
      '<linearGradient id="xm-snow" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffffff"/><stop offset="1" stop-color="#cfdcee"/></linearGradient>' +
      '<linearGradient id="xm-snow2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#b9cde6"/><stop offset="1" stop-color="#8eaad0"/></linearGradient>' + k.blur;
    o.push('<rect width="1600" height="900" fill="url(#xm-sky)"/>');
    o.push(k.stars(90, 520));
    // crescent moon
    o.push('<circle cx="820" cy="300" r="240" fill="url(#xm-mglow)"/>' +
      '<path d="M845 222a84 84 0 1 0 0 156a66 66 0 1 1 0 -156z" fill="#fdf6dc"/>');
    // Santa's sleigh + reindeer crossing the moon
    var deer = function (x) {
      return '<g transform="translate(' + x + ' 0)"><ellipse cx="0" cy="0" rx="16" ry="7"/><path d="M12 -3l8 -10M-12 4l-4 12M-6 5l-2 12M6 5l2 12M12 4l5 11" stroke="#0a1530" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
        '<circle cx="21" cy="-14" r="4"/><path d="M20 -18l-3 -8M17 -24l-5 -2M22 -18l3 -8M25 -24l5 -2" stroke="#0a1530" stroke-width="1.8" fill="none"/></g>';
    };
    o.push('<g><animateTransform attributeName="transform" type="translate" values="420 260;1260 170" dur="22s" repeatCount="indefinite"/>' +
      '<g fill="#0a1530">' + deer(120) + deer(80) + deer(40) +
      '<path d="M-60 6h50l8 -16h10l-6 22c-4 10 -14 14 -26 14h-36c-8 0 -10 -6 -4 -10z"/><path d="M-66 30h70" stroke="#0a1530" stroke-width="3"/>' +
      '<path d="M2 -6L136 -10" stroke="#0a1530" stroke-width="1.5"/><circle cx="-34" cy="-6" r="9"/><path d="M-40 -14l6 -12 6 12z"/></g></g>');
    // snowy hills
    o.push('<path d="M0 650 Q240 580 500 630 T1000 610 T1600 620 V900 H0Z" fill="url(#xm-snow2)"/>');
    // pine helper
    function pine(x, y, s, col) {
      col = col || '#1b5a3c';
      return '<g transform="translate(' + x + ' ' + y + ') scale(' + s + ')"><rect x="-6" y="-14" width="12" height="16" fill="#4a2c1a"/>' +
        '<path d="M0 -150L44 -80H24L58 -30H34L70 -12H-70L-34 -30H-58L-24 -80H-44z" fill="' + col + '"/>' +
        '<path d="M0 -150L20 -118 10 -114 0 -122 -10 -114 -20 -118zM-24 -80L-12 -74 0 -80 12 -74 24 -80 32 -68 -32 -68zM-34 -30L-18 -24 0 -30 18 -24 34 -30 44 -20 -44 -20z" fill="#eef4fb"/></g>';
    }
    [[560, 655, 0.6], [620, 665, 0.75], [1040, 650, 0.65], [1560, 640, 0.9], [1500, 660, 0.6], [430, 662, 0.55]].forEach(function (p) { o.push(pine(p[0], p[1], p[2], '#174a33')); });
    // village hill + cabins
    o.push('<path d="M880 900 V790 Q1020 700 1200 690 Q1400 676 1600 660 V900Z" fill="url(#xm-snow)"/>');
    function cabin(x, y, s, w2) {
      var w = w2 || 150;
      return '<g transform="translate(' + x + ' ' + y + ') scale(' + s + ')">' +
        '<rect x="' + (w * 0.62) + '" y="-150" width="18" height="50" fill="#6b3a26"/>' +
        '<g fill="#e6eef8" opacity=".55">' + [0, 1, 2].map(function (j) {
          return '<circle cx="' + (w * 0.62 + 9) + '" cy="-160" r="' + (8 + j * 3) + '"><animate attributeName="cy" values="-160;-240" dur="5s" begin="-' + (j * 1.6) + 's" repeatCount="indefinite"/><animate attributeName="opacity" values=".7;0" dur="5s" begin="-' + (j * 1.6) + 's" repeatCount="indefinite"/></circle>';
        }).join('') + '</g>' +
        '<rect x="0" y="-90" width="' + w + '" height="90" fill="#6b3a26"/>' +
        '<polygon points="-16,-88 ' + (w / 2) + ',-150 ' + (w + 16) + ',-88" fill="#3d2118"/><path d="M-18 -86 L' + (w / 2) + ' -152 L' + (w + 18) + ' -86 L' + (w + 8) + ' -80 L' + (w / 2) + ' -138 L-8 -80z" fill="#fbfdff"/>' +
        '<circle cx="' + (w / 2) + '" cy="-45" r="60" fill="url(#xm-warm)"/>' +
        '<rect x="' + (w * 0.16) + '" y="-66" width="30" height="28" fill="#ffd27a"><animate attributeName="opacity" values="1;.82;1" dur="3.4s" repeatCount="indefinite"/></rect>' +
        '<rect x="' + (w * 0.62) + '" y="-66" width="30" height="28" fill="#ffd27a"/>' +
        '<rect x="' + (w * 0.42) + '" y="-46" width="24" height="46" fill="#3d2118"/><circle cx="' + (w * 0.42 + 12) + '" cy="-30" r="7" fill="none" stroke="#2e7d4f" stroke-width="3"/>' +
        '<path d="M' + (w * 0.16) + ' -52h30M' + (w * 0.16 + 15) + ' -66v28M' + (w * 0.62) + ' -52h30M' + (w * 0.62 + 15) + ' -66v28" stroke="#6b3a26" stroke-width="2.5"/></g>';
    }
    o.push(cabin(1180, 700, 1) + cabin(1380, 690, 0.8, 130));
    // ground snow
    o.push('<path d="M0 772 Q300 744 600 768 T1200 764 T1600 752 V900 H0Z" fill="url(#xm-snow)"/>');
    // snowman
    o.push('<g transform="translate(960 850)"><circle cx="0" cy="-30" r="38" fill="#fbfdff" stroke="#cfdcee" stroke-width="2"/><circle cx="0" cy="-92" r="28" fill="#fbfdff" stroke="#cfdcee" stroke-width="2"/><circle cx="0" cy="-138" r="21" fill="#fbfdff" stroke="#cfdcee" stroke-width="2"/>' +
      '<path d="M-24 -170H24M-15 -170V-196H15V-170" stroke="#151515" stroke-width="5" fill="#151515"/><rect x="-15" y="-196" width="30" height="26" fill="#151515"/><path d="M-15 -176H15" stroke="#c8102e" stroke-width="4"/>' +
      '<circle cx="-7" cy="-142" r="2.6" fill="#151515"/><circle cx="7" cy="-142" r="2.6" fill="#151515"/><path d="M0 -136l16 4 -16 3z" fill="#f08a2a"/>' +
      '<path d="M-24 -118q24 10 48 0l-2 8q-22 8 -44 0z" fill="#c8102e"/><path d="M14 -112l6 24 8 -2 -6 -22z" fill="#c8102e"/>' +
      '<circle cx="0" cy="-98" r="3" fill="#151515"/><circle cx="0" cy="-84" r="3" fill="#151515"/><path d="M-26 -96l-34 -22M26 -96l34 -22" stroke="#5a3a24" stroke-width="4" stroke-linecap="round"/></g>');
    // big decorated tree (left foreground) with twinkling lights + star + presents
    var TS = 1.7, TH = 150 * TS;
    var big = '<g transform="translate(120 900)">' + pine(0, 0, TS, '#1b5a3c');
    var bulbs = ['#ff4d4d', '#ffd23f', '#4dd2ff', '#7dff6b', '#ff8af2'];
    for (var b = 0; b < 26; b++) {
      var up = 20 + rnd() * (TH - 50), by = -up;
      var bx = (rnd() - 0.5) * 2 * 0.8 * 70 * TS * (1 - up / TH);
      big += '<circle cx="' + f(bx) + '" cy="' + f(by) + '" r="' + f(4 + rnd() * 2.5) + '" fill="' + bulbs[b % 5] + '"><animate attributeName="opacity" values="1;.35;1" dur="' + f(1 + rnd() * 1.8) + 's" begin="-' + f(rnd() * 2) + 's" repeatCount="indefinite"/></circle>';
    }
    big += '<g transform="translate(0 ' + (-TH - 6) + ')"><circle r="34" fill="url(#xm-warm)"/><path d="M0 -20l6 13 14 1 -11 9 4 14 -13 -8 -13 8 4 -14 -11 -9 14 -1z" fill="#ffd23f"/></g>';
    big += '<rect x="-110" y="-40" width="48" height="40" fill="#c8102e"/><path d="M-86 -40v40M-110 -20h48" stroke="#ffd23f" stroke-width="6"/>' +
      '<rect x="60" y="-32" width="44" height="32" fill="#1f7a45"/><path d="M82 -32v32M60 -16h44" stroke="#f3f3f3" stroke-width="5"/>' +
      '<rect x="-40" y="-28" width="36" height="28" fill="#2b6fd1"/><path d="M-22 -28v28M-40 -14h36" stroke="#ffd23f" stroke-width="4"/>' + '</g>';
    o.push(big);
    // falling snow
    o.push(k.fall(70, function (i) { return '<circle r="' + (1.5 + (i % 4)) + '" fill="#fff" opacity="' + (0.55 + (i % 5) * 0.09) + '"/>'; }, 0, 1600, 10, 20, false));
    o.push('<g filter="url(#sc-blur)" fill="#ffffff"><ellipse cx="800" cy="890" rx="900" ry="26" opacity=".25"/></g>');
    return k.svg(defs, o.join(''));
  }

  function newyearSvg() {
    var k = sceneKit(37), f = k.f, rnd = k.rnd, o = [];
    var defs = '<linearGradient id="ny-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#03030d"/><stop offset=".6" stop-color="#14103a"/><stop offset="1" stop-color="#2e2266"/></linearGradient>' +
      '<linearGradient id="ny-river" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#1a1545"/><stop offset="1" stop-color="#05040f"/></linearGradient>' +
      k.glowDef('ny-gold', '#ffd76a', 0.6) + k.glowDef('ny-clock', '#fff3c4', 0.8) + k.blur;
    o.push('<rect width="1600" height="900" fill="url(#ny-sky)"/>');
    o.push(k.stars(60, 420));
    // fireworks: bursts of rays that grow and fade, staggered
    function burst(x, y, r, col, dur, begin) {
      var rays = '';
      for (var i = 0; i < 18; i++) {
        var a = i / 18 * Math.PI * 2, x2 = f(Math.cos(a) * r), y2 = f(Math.sin(a) * r);
        rays += '<path d="M' + f(x2 * 0.25) + ' ' + f(y2 * 0.25) + 'L' + x2 + ' ' + y2 + '" stroke="' + col + '" stroke-width="3" stroke-linecap="round"/><circle cx="' + x2 + '" cy="' + y2 + '" r="3.5" fill="' + col + '"/>';
      }
      return '<g transform="translate(' + x + ' ' + y + ')"><circle r="' + (r * 1.4) + '" fill="url(#ny-gold)" opacity="0"><animate attributeName="opacity" values="0;.7;0;0" keyTimes="0;.15;.6;1" dur="' + dur + 's" begin="' + begin + 's" repeatCount="indefinite"/></circle>' +
        '<g opacity="0">' + rays +
        '<animate attributeName="opacity" values="0;1;1;0;0" keyTimes="0;.05;.4;.7;1" dur="' + dur + 's" begin="' + begin + 's" repeatCount="indefinite"/>' +
        '<animateTransform attributeName="transform" type="scale" values=".1;1;1.15;1.15" keyTimes="0;.35;.7;1" dur="' + dur + 's" begin="' + begin + 's" repeatCount="indefinite"/></g></g>';
    }
    o.push(burst(820, 290, 110, '#ffd76a', 4.2, 0) + burst(640, 115, 70, '#ff6fb5', 3.6, -1.2) + burst(1110, 190, 90, '#6fe7ff', 3.9, -2.4) +
      burst(1350, 330, 70, '#9dff7a', 3.4, -0.6) + burst(250, 105, 55, '#ffa04d', 4.6, -3.1) + burst(960, 120, 55, '#ffffff', 3.1, -1.8));
    // skyline silhouette with lit windows
    var sky = '<g fill="#0a0820">', wins = '<g fill="#ffd98a">';
    var x = 0, bh = [210, 300, 170, 360, 240, 190, 280, 150, 330, 220, 260, 180, 310, 200, 240, 170, 290];
    for (var i = 0; x < 1600; i++) {
      var w = 70 + rnd() * 70, h = bh[i % bh.length] * (0.8 + rnd() * 0.4), top = 790 - h;
      if (x > 1120 && x < 1240) { x += w; continue; } // room for the clock tower
      sky += '<rect x="' + f(x) + '" y="' + f(top) + '" width="' + f(w - 6) + '" height="' + f(h) + '"/>';
      for (var wy = top + 16; wy < 770; wy += 22) for (var wx = x + 10; wx < x + w - 18; wx += 18) if (rnd() < 0.32) wins += '<rect x="' + f(wx) + '" y="' + f(wy) + '" width="7" height="10" opacity="' + f(0.5 + rnd() * 0.5) + '"/>';
      x += w;
    }
    sky += '</g>'; wins += '</g>';
    o.push(sky + wins);
    // clock tower at midnight
    o.push('<g transform="translate(1180 790)" fill="#0a0820"><rect x="-38" y="-360" width="76" height="360"/><polygon points="-46,-360 0,-460 46,-360"/><rect x="-2" y="-490" width="4" height="34"/>' +
      '<circle cx="0" cy="-300" r="70" fill="url(#ny-clock)"/><circle cx="0" cy="-300" r="28" fill="#fff6d6" stroke="#0a0820" stroke-width="3"/>' +
      '<path d="M0 -300V-322M0 -300V-319" stroke="#0a0820" stroke-width="4" stroke-linecap="round"/><path d="M0 -300l-2 -24" stroke="#0a0820" stroke-width="2.5"/>' +
      '<g fill="#ffd98a"><rect x="-14" y="-240" width="10" height="16"/><rect x="4" y="-240" width="10" height="16"/><rect x="-14" y="-190" width="10" height="16"/><rect x="4" y="-190" width="10" height="16"/></g></g>');
    // river with shimmering reflections
    o.push('<rect x="0" y="790" width="1600" height="110" fill="url(#ny-river)"/>');
    var refl = '';
    for (var r2 = 0; r2 < 40; r2++) {
      var rx = f(rnd() * 1600), ry = f(800 + rnd() * 90), col = ['#ffd76a', '#ff6fb5', '#6fe7ff', '#ffd98a'][r2 % 4];
      refl += '<rect x="' + rx + '" y="' + ry + '" width="' + f(14 + rnd() * 40) + '" height="2.5" fill="' + col + '" opacity=".5"><animate attributeName="opacity" values=".15;.7;.15" dur="' + f(1.5 + rnd() * 2) + 's" begin="-' + f(rnd() * 2) + 's" repeatCount="indefinite"/></rect>';
    }
    o.push(refl);
    // confetti
    var cc = ['#ffd76a', '#ff6fb5', '#6fe7ff', '#9dff7a', '#ffffff', '#ffa04d'];
    o.push(k.fall(32, function (i) { return '<rect x="-4" y="-7" width="8" height="14" rx="2" fill="' + cc[i % 6] + '"/>'; }, 0, 1600, 9, 16, true));
    return k.svg(defs, o.join(''));
  }

  var SCENES = {
    halloween: { svg: function () { return hauntedSvg(); }, bg: '#0b0a1e', a: '#ffcf5a', b: '#ff7a1a', eyebrow: '#ffb347', btn: '#ff7a1a', btnText: '#1a0f24', glow: 'rgba(255,154,42,.42),rgba(140,60,200,.18)', phone: '500 0 1100 900' },
    thanksgiving: { svg: thanksgivingSvg, bg: '#1c1836', a: '#ffe08a', b: '#ff9a3c', eyebrow: '#ffc56b', btn: '#f08a2a', btnText: '#2a1208', glow: 'rgba(255,190,90,.45),rgba(200,80,40,.18)', phone: '500 0 1100 900' },
    christmas: { svg: christmasSvg, bg: '#050f26', a: '#ffe08a', b: '#f3c63f', eyebrow: '#ff8a8a', btn: '#c8102e', btnText: '#ffffff', glow: 'rgba(255,230,160,.4),rgba(120,170,255,.2)', phone: '520 0 1080 900' },
    newyear: { svg: newyearSvg, bg: '#03030d', a: '#fff1b0', b: '#f3c63f', eyebrow: '#ffd76a', btn: '#f3c63f', btnText: '#14103a', glow: 'rgba(255,215,106,.45),rgba(255,111,181,.18)', phone: '500 0 1100 900' }
  };

  function sceneCss(t) {
    return 'html.llc-scened .llc-hero{background:' + t.bg + ' !important}' +
      'html.llc-scened .llc-hero-bg{background:' + t.bg + '}' +
      'html.llc-scened .llc-bubble{display:none !important}' +
      'html.llc-scened .llc-haunt{position:absolute;left:0;right:0;bottom:0;height:min(100%,max(56.25vw,420px));pointer-events:none}' +
      'html.llc-scened .llc-haunt svg{display:block;width:100%;height:100%}' +
      'html.llc-scened .llc-haunt-scrim{position:absolute;inset:0;pointer-events:none;background:radial-gradient(ellipse 60% 55% at 26% 46%,rgba(8,6,20,.72),rgba(8,6,20,0) 70%)}' +
      '@media (max-width:989px){html.llc-scened .llc-haunt-scrim{background:linear-gradient(180deg,rgba(8,6,20,.35),rgba(8,6,20,0) 60%)}}' +
      'html.llc-scened .llc-hero-h1{color:#fff !important;text-shadow:0 2px 18px rgba(0,0,0,.55)}' +
      'html.llc-scened .llc-hero-h1 > span:nth-last-of-type(-n+2) .llc-word{background:linear-gradient(92deg,' + t.a + ' 10%,' + t.b + ' 90%) !important;-webkit-background-clip:text !important;background-clip:text !important;color:transparent !important;text-shadow:none}' +
      'html.llc-scened .llc-hero-sub{color:rgba(255,255,255,.84) !important}' +
      'html.llc-scened .llc-hero .llc-eyebrow{color:' + t.eyebrow + ' !important}' +
      'html.llc-scened .llc-hero .llc-eyebrow::before{background:' + t.eyebrow + ' !important}' +
      'html.llc-scened .llc-hero-stats{border-top-color:rgba(255,255,255,.18) !important}' +
      'html.llc-scened .llc-hero-stat-num{color:#fff !important}' +
      'html.llc-scened .llc-hero-stat-label{color:rgba(255,255,255,.66) !important}' +
      'html.llc-scened .llc-hero .llc-btn:not(.llc-btn--ghost){background:' + t.btn + ' !important;color:' + t.btnText + ' !important;box-shadow:0 0 28px ' + t.btn + '73}' +
      'html.llc-scened .llc-hero .llc-btn--ghost{color:#fff !important;border-color:rgba(255,255,255,.55) !important;background:rgba(5,5,20,.35) !important}' +
      'html.llc-scened .llc-hero .llc-3ds-pill:not(.is-active){color:rgba(255,255,255,.75) !important}' +
      'html.llc-scened .llc-hero .llc-3ds-pill.is-active{background:' + t.btn + ' !important;color:' + t.btnText + ' !important}' +
      'html.llc-scened .llc-hero .llc-scroll-cue{color:rgba(255,255,255,.6) !important}' +
      'html.llc-scened .llc-hero .llc-stage-glow{background:radial-gradient(circle,' + t.glow + ' 55%,rgba(0,0,0,0) 72%) !important;opacity:1 !important}' +
      'html.llc-scened .llc-hero .llc-stage-suds{display:none !important}';
  }

  function decorateScene(bg, t) {
    var hero = bg.closest('.llc-hero');
    var st = document.createElement('style');
    st.textContent = sceneCss(t);
    document.head.appendChild(st);
    document.documentElement.classList.add('llc-scened', 'llc-scened--' + season);
    var scene = document.createElement('div');
    scene.className = 'llc-scene llc-haunt';
    scene.setAttribute('aria-hidden', 'true');
    scene.innerHTML = t.svg();
    bg.appendChild(scene);
    var scrim = document.createElement('div');
    scrim.className = 'llc-scene llc-haunt-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    bg.appendChild(scrim);
    var svgEl = scene.querySelector('svg');
    // phones: frame the best part of the scene instead of the dead center
    function fit() { if (svgEl) svgEl.setAttribute('viewBox', window.innerWidth < 750 ? t.phone : '0 0 1600 900'); }
    fit();
    window.addEventListener('resize', fit);
    if (reduced && svgEl && svgEl.pauseAnimations) svgEl.pauseAnimations();
    // pause the scene's animation when the hero is off screen (saves battery)
    if (svgEl && svgEl.pauseAnimations && 'IntersectionObserver' in window && !reduced) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) svgEl.unpauseAnimations(); else svgEl.pauseAnimations(); }); }).observe(hero || bg);
    }
  }

  function decorateHero() {
    var bg = document.querySelector('.llc-hero .llc-hero-bg');
    if (!bg || bg.querySelector('.llc-scene')) return;
    if (SCENES[season]) { decorateScene(bg, SCENES[season]); return; }
    var bubbles = bg.querySelectorAll('.llc-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var sp = cfg.sprites(i + 1);
      bubbles[i].classList.add('llc-bubble--season');
      bubbles[i].innerHTML = sp.html;
    }
    var moon = document.createElement('div');
    moon.className = 'llc-scene llc-scene--moon';
    moon.setAttribute('aria-hidden', 'true');
    moon.innerHTML = MOON[cfg.scene];
    bg.appendChild(moon);
    var ground = document.createElement('div');
    ground.className = 'llc-scene llc-scene--ground';
    ground.setAttribute('aria-hidden', 'true');
    ground.innerHTML = groundSvg(cfg.scene);
    bg.appendChild(ground);
    hideOverlaps();
  }

  // Never let a decoration sit on the headline, copy, buttons or stats
  function hideOverlaps() {
    var guard = document.querySelectorAll('.llc-hero .llc-hero-copy > *');
    var boxes = [];
    for (var k = 0; k < guard.length; k++) boxes.push(guard[k].getBoundingClientRect());
    var bubbles = document.querySelectorAll('.llc-bubble--season');
    for (var i = 0; i < bubbles.length; i++) {
      var r = bubbles[i].getBoundingClientRect(), hit = false;
      for (var j = 0; j < boxes.length && !hit; j++) {
        var b = boxes[j];
        hit = r.left < b.right && r.right > b.left && r.top < b.bottom && r.bottom > b.top;
      }
      bubbles[i].classList.toggle('llc-bubble--hide', hit);
    }
  }
  window.addEventListener('resize', function () { try { hideOverlaps(); } catch (e) {} });
  window.addEventListener('load', function () { try { hideOverlaps(); } catch (e) {} });
  function heroWhenReady() { try { decorateHero(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroWhenReady);
  else heroWhenReady();

  if (reduced) return; // no moving pieces beyond this point

  // ---------- Side-margin decorations (desktop only) ----------
  function rand(a, b) { return a + Math.random() * (b - a); }

  function gutterWidth() {
    if (window.innerWidth < 990) return 0;
    var el = document.querySelector('#MainContent .page-width') || document.querySelector('.header.page-width');
    if (!el) return 0;
    var r = el.getBoundingClientRect();
    var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
    return Math.floor(r.left + pad - 16);
  }

  function buildSide(side, width, height) {
    var box = document.createElement('div');
    box.className = 'llc-gutter llc-gutter--' + side;
    box.setAttribute('aria-hidden', 'true');
    box.style.width = width + 'px';
    var count = Math.max(3, Math.min(8, Math.round(height / 170)));
    var base = Math.max(22, Math.min(46, width * 0.32));
    for (var i = 0; i < count; i++) {
      var sp = cfg.sprites(i + (side === 'right' ? 2 : 0));
      var size = Math.round(base * sp.size);
      var item = document.createElement('div');
      var inner = document.createElement('div');
      item.className = 'llc-item';
      inner.className = 'llc-inner';
      inner.innerHTML = sp.html;
      item.style.width = size + 'px';
      item.style.height = (sp.kind === 'confetti' ? Math.round(size * 1.75) : (sp.kind === 'bat' ? Math.round(size / 2) : size)) + 'px';
      item.style.left = Math.round(rand(6, Math.max(8, width - size - 6))) + 'px';

      if (cfg.mode === 'flutter') {
        item.style.top = Math.round(rand(0.14, 0.86) * height) + 'px';
        var maxDx = Math.max(6, (width - size) / 4);
        item.style.setProperty('--dx', Math.round(rand(-maxDx, maxDx)) + 'px');
        item.style.setProperty('--dy', Math.round(rand(-40, 40)) + 'px');
        item.style.animation = 'llc-drift ' + rand(7, 12).toFixed(1) + 's ease-in-out ' + (-rand(0, 10)).toFixed(1) + 's infinite alternate';
        if (sp.kind === 'bat') inner.style.animation = 'llc-flap ' + rand(0.22, 0.35).toFixed(2) + 's ease-in-out infinite alternate';
        if (sp.kind === 'ghost' || sp.kind === 'bob') inner.style.animation = 'llc-bob ' + rand(1.8, 2.6).toFixed(1) + 's ease-in-out infinite alternate';
        if (sp.kind === 'ghost') item.style.opacity = '0.9';
      } else if (sp.kind === 'twinkle') {
        item.style.top = Math.round(rand(0.15, 0.85) * height) + 'px';
        inner.style.animation = 'llc-twinkle ' + rand(2, 3.5).toFixed(1) + 's ease-in-out ' + (-rand(0, 3)).toFixed(1) + 's infinite';
      } else {
        item.style.top = '0px';
        item.style.setProperty('--fall', (height + 60) + 'px');
        var dur = sp.kind === 'snow' ? rand(11, 18) : (sp.kind === 'confetti' ? rand(8, 13) : rand(10, 16));
        item.style.animation = 'llc-fall ' + dur.toFixed(1) + 's linear ' + (-rand(0, dur)).toFixed(1) + 's infinite';
        inner.style.setProperty('--sx', Math.round(rand(-Math.min(18, width / 6), Math.min(18, width / 6))) + 'px');
        inner.style.setProperty('--rot', Math.round(rand(-120, 120)) + 'deg');
        inner.style.animation = 'llc-sway ' + rand(3, 5).toFixed(1) + 's ease-in-out ' + (-rand(0, 4)).toFixed(1) + 's infinite';
        if (sp.kind === 'snow') item.style.opacity = rand(0.65, 0.95).toFixed(2);
      }
      item.appendChild(inner);
      box.appendChild(item);
    }
    document.body.appendChild(box);
  }

  var lastW = -1;
  function layout() {
    var w = gutterWidth();
    if (w === lastW) return;
    lastW = w;
    document.querySelectorAll('.llc-gutter').forEach(function (n) { n.remove(); });
    if (w < 80) return; // no empty margin: show nothing beside the products
    var h = window.innerHeight - 110;
    buildSide('left', w, h);
    buildSide('right', w, h);
  }

  var t;
  function onResize() { clearTimeout(t); t = setTimeout(function () { lastW = -1; layout(); }, 200); }

  function start() {
    try { layout(); } catch (e) {}
    window.addEventListener('resize', onResize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
